// HashRedirect.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function HashRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    const h = window.location.hash;
    if (h && h.startsWith("#/")) {
      navigate(h.slice(1), { replace: true }); // "#/logout" -> "/logout"
    }
  }, [navigate]);
  return null;
}
